import "flatpickr/dist/themes/material_blue.css";
import "flatpickr/dist/themes/material_green.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import DepartmentLayout from "./Components/DepartmentLayout";
import LoginPR from "./Components/LoginPR";
import VenderLayout from "./Components/VenderLayout";
import { mainRouteInitial } from "./Data/Constant";
import CloseVendorList from "./Pages/CloseVendorLIst";
import ComplianceDashboard from "./Pages/ComplianceDashboard";
import DailyCloseVendorList from "./Pages/DailyCloseVendorList";
import DepartmentSplash from "./Pages/DepartmentSplash";
import DepartmentVendorLIst from "./Pages/DepartmentVendorLIst";
import MyShop from "./Pages/MyShop";
import OpenVendorList from "./Pages/OpenVendorLIst";
import RegisterNewVendor from "./Pages/RegisterNewVendor";
import RegisterNewVendorPR from "./Pages/RegisterNewVendor/RegisterNewVendorPR";
import RegisterVendorList from "./Pages/RegisterVendorList";
import ShopNotOperate from "./Pages/ShopNotOperate";
import ShopOpenCloseList from "./Pages/ShopOpenCloseList";
import VenderDashboard from "./Pages/VenderDashboard";
import VenderRegistration from "./Pages/VenderRegistration";
import VendorLogin from "./Pages/VendorLogin";
import ViolationVendorList from "./Pages/ViolationVendorList";
import ScanPage from "./Pages/DepartmentVendorLIst/scanQrModal";
import AddUserForm from "./Pages/AddUserForm";
import ViewUserList from "./Pages/ViewUser";

function App() {
  const router = createBrowserRouter([
    {
      path: `/${mainRouteInitial}/`,
      element: <VenderLayout />,
      children: [
        //Vender Routes
        {
          path: "VendorDashboard",
          element: <VenderDashboard />,
        },
        {
          path: "MyShop",
          element: <MyShop />,
        },
      ],
    },
    {
      path: `/${mainRouteInitial}/`,
      element: <DepartmentLayout />,
      children: [
        //Vender Routes
        {
          path: "ComplianceDashboard",
          element: <ComplianceDashboard />,
        },
        {
          path: "VendorList",
          element: <DepartmentVendorLIst />,
        },
        {
          path: "violations",
          element: <ViolationVendorList />,
        },
        {
          path: "shopOpenClose",
          element: <ShopOpenCloseList />,
        },
        {
          path: "dailyClose",
          element: <DailyCloseVendorList />,
        },
        {
          path: "openShop",
          element: <OpenVendorList />,
        },
        {
          path: "closeShop",
          element: <CloseVendorList />,
        },
        {
          path: "shopNotOperate",
          element: <ShopNotOperate />,
        },
        {
          path: "VendorRegistration",
          element: (
            <RegisterNewVendorPR>
              <RegisterNewVendor />
            </RegisterNewVendorPR>
          ),
        },
        {
          path: "VendorRegistrationForm",
          element: <VenderRegistration />,
        },
        {
          path: "registerVendorList",
          element: <RegisterVendorList />,
        },
        {
          path: "addUser",
          element: <AddUserForm />,
        },
        {
          path: "viewUser",
          element: <ViewUserList />,
        },
      ],
    },
    {
      path: "VendorLogin",
      element: (
        <LoginPR>
          <VendorLogin />
        </LoginPR>
      ),
    },
    {
      path: "DepartmentLogin",
      element: (
        <LoginPR>
          <DepartmentSplash />
        </LoginPR>
      ),
    },
    {
      path: "/scan",
      element: <ScanPage />,
    },

    {
      path: "/",
      element: "No Page Found",
    },
  ]);
  return <RouterProvider router={router} />;
}

export default App;
